import { Pipe, PipeTransform } from '@angular/core';
import {format, parseISO, setDefaultOptions} from "date-fns";
import {de} from "date-fns/locale";

@Pipe({
  name: 'yomaDateFormat',
  standalone: true
})
export class YomaDateFormatPipe implements PipeTransform {

  transform(value: string | number | Date | undefined, dateFormat: string, useTimezone: boolean = false ): string {
    setDefaultOptions({ locale: de })
    if (!value) return ''
    if (typeof value === 'string') {
      let str = value;
      if (useTimezone && !str.endsWith('Z') && !str.includes('+')) {
        str += 'Z';
      }
      const date = parseISO(str);
      return format(date, dateFormat);
    } else if (typeof value === 'number') {
      return format(value * 1000, dateFormat);
    }
    else {
      return format(value, dateFormat);
    }
  }

}
